const M: Readonly<Record<string, string>> = {
  p00: "foundations",
  p01: "foundations",
  p02: "foundations",
  p03: "foundations",
  p04: "foundations",
  p05: "foundations",
  p06: "foundations",
  p07: "foundations",
  p10: "trust_reasoning",
  p11: "trust_reasoning",
  p12: "evidence",
  p13: "privacy",
  p14: "trust_reasoning",
  p15: "privacy",
  p16: "evidence",
  p17: "prompting",
  p20: "context",
  p21: "context",
  p22: "system_safety",
  p23: "evidence",
  p24: "trust_reasoning",
  p25: "trust_reasoning",
  p26: "system_safety",
  p27: "privacy",
  p30: "retrieval",
  p31: "model_theory",
  p32: "retrieval",
  p33: "tools_agents",
  p34: "tools_agents",
  p35: "system_safety",
  p36: "system_safety",
  p37: "context",
  p40: "model_theory",
  p41: "model_theory",
  p42: "tools_agents",
  p43: "adversarial",
  p44: "privacy",
  p45: "model_theory",
  p46: "model_theory",
  p47: "model_theory",
  p50: "trust_reasoning",
  p51: "privacy",
  p52: "adversarial",
  p53: "system_safety",
  p54: "model_theory",
  p55: "model_theory",
  p56: "tools_agents",
  p57: "model_theory",
  p60: "model_theory",
  p61: "tools_agents",
  p62: "research_frontier",
  p63: "model_theory",
  p64: "model_theory",
  p65: "research_frontier",
  p66: "tools_agents",
  p67: "tools_agents",
  // C.1 — 2026-04-25 — see docs/plans/2026-04-25-c1-ai-literacy-content-*.md
  p70: "prompting",
  p71: "prompting",
  p72: "prompting",
  p73: "prompting",
  p74: "prompting",
  p75: "verification_workflow",
  p76: "verification_workflow",
  p77: "verification_workflow",
  p78: "verification_workflow",
  p79: "verification_workflow",
  p80: "adversarial",
  p81: "adversarial",
  p82: "adversarial",
  p83: "adversarial",
  p84: "adversarial",
  p85: "deepfakes_scams",
  p86: "deepfakes_scams",
  p87: "deepfakes_scams",
  p88: "deepfakes_scams",
  p89: "deepfakes_scams",
  p90: "bias_ethics",
  p91: "bias_ethics",
  p92: "bias_ethics",
  p93: "bias_ethics",
  p94: "bias_ethics",
  p95: "bias_ethics",
  p96: "research_frontier",
  p97: "research_frontier",
  p98: "research_frontier",
  p99: "research_frontier",
  pa0: "retrieval",
};

export function conceptForQuestionId(id: string): string {
  return M[id] ?? "foundations";
}
